export default "__VITE_ASSET__Bwtyr9bP__"